import ClientGraphql, { getOperationName } from '../../tools/client-graphql'
import { getEndpointModifierForOperation } from '../../tools/endpoint-modifier'
import { querySearchProducts } from '../queries/search-products'
import { querySearchProductsForStore } from '../queries/search-products-for-store'
import { querySearchSimilarProducts } from '../queries/search-similar-products'
import { querySearchAggregations } from '../queries/search-aggregations'
import { querySearchAggregationsForStore } from '../queries/search-aggregations-for-store'
import { querySearchSizes } from '../queries/search-sizes'
import { querySearchSizesForStore } from '../queries/search-sizes-for-store'
import { querySearchSubCategory } from '../queries/search-sub-category'
import { querySearchSubCategoryForStore } from '../queries/search-sub-category-for-store'
import { querySearchFeaturedStores } from '../queries/search-featured-stores'

const AGGREGATIONS_QUERIES = {
  all: {
    normal: querySearchAggregations,
    store: querySearchAggregationsForStore
  },
  sizes: {
    normal: querySearchSizes,
    store: querySearchSizesForStore
  },
  sub_categories: {
    normal: querySearchSubCategory,
    store: querySearchSubCategoryForStore
  }
}

export default class SearchProducts {
  constructor(endpoint) {
    this.currentVariables = {}
    this.clientGraphql = new ClientGraphql({ endpoint })
  }

  isFetchForStore() {
    return !!this.currentVariables.seller_id
  }

  fetch({ variables = {}, endpointModifier = null } = {}) {
    this.setCurrentVariables(variables)
    variables = Object.assign({}, this.currentVariables)

    const query = this.isFetchForStore() ? querySearchProductsForStore : querySearchProducts
    endpointModifier = endpointModifier || getEndpointModifierForOperation(getOperationName(query))

    // Remove variables only relevant to aggregations search.
    delete variables.brands_quantity

    return this.clientGraphql.fetch({ query, variables, endpointModifier })
  }

  fetchSimilar({ variables = {}, endpointModifier = null } = {}) {
    this.setCurrentVariables(variables)
    variables = Object.assign({}, this.currentVariables)

    const query = querySearchSimilarProducts

    // Remove variables only relevant to aggregations search.
    delete variables.brands_quantity

    return this.clientGraphql.fetch({ query, variables, endpointModifier })
  }

  fetchFeaturedStores({ variables = {}, endpointModifier = 'featured-stores' }) {
    this.setCurrentVariables(variables)
    variables = { ...this.currentVariables }

    const query = querySearchFeaturedStores

    // Remove variables only relevant to aggregations search.
    delete variables.brands_quantity

    return this.clientGraphql.fetch({ query, variables, endpointModifier})
  }

  fetchAggregations({ variables = {}, filter = null } = {}) {
    variables = Object.assign({}, this.currentVariables, variables)
    filter = filter || 'all'

    const typeQuery = this.isFetchForStore() ? 'store' : 'normal'
    const query = AGGREGATIONS_QUERIES[filter][typeQuery]
    const endpointModifier = getEndpointModifierForOperation(getOperationName(query))

    // Remove variables only relevant to products search.
    delete variables.first
    delete variables.after
    delete variables.sort
    delete variables.new_buyer
    delete variables.search_id
    delete variables.search_context

    return this.clientGraphql.fetch({ query, variables, endpointModifier })
  }

  enforceCurrentVariableAsString(key) {
    const value = this.currentVariables[key]

    if (value && typeof value !== 'string') {
      this.currentVariables[key] = value.toString()
    }
  }

  setCurrentVariables(variables) {
    this.currentVariables = Object.assign({}, variables)

    if (!this.currentVariables.term) {
      this.currentVariables.term = ''
    }

    this.enforceCurrentVariableAsString('seller_id')
    this.enforceCurrentVariableAsString('owner_id')
    this.enforceCurrentVariableAsString('user_id')
    this.enforceCurrentVariableAsString('product_id')
    this.enforceCurrentVariableAsString('plan_id')
  }
}
